import { GameGeneratorSchema } from "@fapinstructor/common";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { fapinstructorApi } from "../../api";

export const GAME_GENERATOR_QUERY_KEY = "games-generator";

export function getGameGeneratorQueryKey({
  gameGeneratorId,
}: GetGameGeneratorParams) {
  return [GAME_GENERATOR_QUERY_KEY, "detail", gameGeneratorId];
}

type GetGameGeneratorParams = {
  gameGeneratorId: string;
};

async function getGameGenerator({ gameGeneratorId }: GetGameGeneratorParams) {
  return await fapinstructorApi
    .get(`/game-generator/${gameGeneratorId}`)
    .json(GameGeneratorSchema);
}

export function useGameGenerator(params: GetGameGeneratorParams) {
  const query = useQuery(gameGeneratorQueryOptions(params));
  return query;
}

export const gameGeneratorQueryOptions = (params: GetGameGeneratorParams) =>
  queryOptions({
    queryKey: getGameGeneratorQueryKey(params),
    queryFn: () => getGameGenerator(params),
    throwOnError: true,
  });
